const arquivo_de_alunos_reordenados = {
  path: "/arquivo-de-alunos-reordenados",
  redirect: "/arquivo-de-alunos-reordenados",
  meta: {
    breadCrumb: "Processo de Matrículas - Reordenamento",
  },
  children: [
    {
      path: "/arquivo-de-alunos-reordenados",
      name: "arquivo_de_alunos_reordenados",
      component: () =>
        import(
          "@/views/ArquivoDeAlunosReordenados/ArquivoDeAlunosReordenadosHome.vue"
        ),
    },
  ],
};

export { arquivo_de_alunos_reordenados };
